module.exports = __webpack_public_path__ + "img/4-3-ribbons-2.01e88992.jpg";